import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';

let SeparationAssumedDrySection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, namePrefix }) => {
  const isWholePortion = namePrefix?.endsWith('WholePortion') ?? false;
  const isWashed = useSelector(pipe(createWorksheetSelector!(`Washing.IsWashed`), valueOrDefault(false)));

  return (
    <>
      <ListFieldSection heading="Coarse Portion Mass">
        {isWholePortion && <Field input={<TextOutput />} name="Masses.DryMass" label="Specimen Total Dry Mass" />}
        {isWholePortion && isWashed && <Field input={<TextOutput />} name="Washing.WashedDryMass" />}
        <Field input={<TextOutput />} name="Separation.CoarsePortion.Masses.DryMass" />
        <Field input={<TextOutput />} name="Separation.FinePortion.Masses.DryMass" />
      </ListFieldSection>

      <ListFieldSection heading="Fine Portion Subspecimen Mass">
        <NamePrefixModifier appendNamePrefix="Separation.FinePortion.Subspecimen.Masses">
          <WorksheetBalanceFieldSet
            name="MassMeasurement.Equipment.Balance"
            copyTo={['MassMeasurement.Equipment.DryMassBalance']}
          />
          <Field input={<NumericInput />} name="MassMeasurement.TareMass" />
          <Field input={<NumericInput />} name="MassMeasurement.TareAndDryMass" />
          <Field input={<TextOutput />} name="DryMass" />
        </NamePrefixModifier>
      </ListFieldSection>
    </>
  );
};

SeparationAssumedDrySection = withInjectedProps(SeparationAssumedDrySection);

export { SeparationAssumedDrySection };
export default SeparationAssumedDrySection;
